// extracted by mini-css-extract-plugin
module.exports = {"container":"_2jGrSD1IjwlJimkR8bBNiu","text":"FcFnsWehsXBrdQ8jCNgB0"};